/**
 * Read the connected wallet address from the Web3Auth provider locally.
 *
 * Uses the `eth_accounts` JSON-RPC method, which the Web3Auth wallet middleware
 * resolves from the in-memory private key WITHOUT any network round-trip. This
 * deliberately avoids constructing a web3.js RPC client, whose chain-data calls
 * are routed to the Web3Auth Infura proxy and can intermittently return HTTP 401
 * ("Non-200 status code: '401'") on login.
 *
 * v11 note: the call is unchanged; only the handle it is given moved. v9 passed
 * `web3auth.provider` and needed a hand-rolled `EvmRequestProvider` shape for it.
 * v11 hands out `web3auth.connection.ethereumProvider`, which is a typed
 * `IProvider` — the same EIP-1193 surface under a new home.
 */
import type { IProvider } from '@web3auth/modal';

export async function resolveWalletAddress(provider: IProvider): Promise<string | undefined> {
  const accounts = await provider.request<never, string[]>({ method: 'eth_accounts' });
  return accounts?.[0];
}
